import { config } from '../config';
import { getHeaders } from './getHeaders';
import { getEmailOverrideParams } from './getEmailOverrideParams';

export const declineQuote = (opportunityId: string) =>
  fetch(
    `${
      config.apiBaseUrl
    }/api/v1/opportunities/${opportunityId}/quote/decline${getEmailOverrideParams()}`,
    {
      headers: getHeaders(),
    },
  );
